import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../store';
import SliderListItem from '../../../../../list-items/SliderListItem';
import { previewHistoryBatch } from '../../../store/extensions';

const LyricsSizeListItem = (props) => {
    const { lyricsFontSize, updateLyricsStyle, maxFontSize } = props;

    const onTextSizeChange = (value) => {
        previewHistoryBatch.start();
        updateLyricsStyle({ fontSize: value });
    };
    
    return (
        <SliderListItem
            title='Size'
            value={lyricsFontSize}
            displayMultiplier={1}
            min={1}
            max={maxFontSize}
            step={1}
            onValueChange={onTextSizeChange}
        />
    );
};

const mapStateToProps = (state) => {
    const { fontSize: lyricsFontSize } = state.createPreview.present.videoSettings.lyrics.style;
    const { maxFontSize } = state.create.maxValues;

    return { 
        lyricsFontSize,
        maxFontSize 
    };
}

const mapDispatchToProps = (dispatch) => {
    const updateLyricsStyle = (properties) => dispatch(createActions.updateLyricsStyle(properties));
    return { updateLyricsStyle }
}

export default connect(mapStateToProps, mapDispatchToProps)(LyricsSizeListItem);